import React from 'react'

export default ({
    options,
    value = [],
    handleChange,
    single = false,
    type
}) => {
    const _handleChange = term => {
        if(single || type === 'radios'){
            return handleChange([term])
        }
        
        let newValues = [...value]

        const termIndexIfExists = newValues.indexOf(term)

        if(termIndexIfExists === -1){
            newValues.push(term)
        }else{
            newValues.splice(termIndexIfExists, 1)
        }

        handleChange(newValues)
    }

    const lines = typeof options === 'string' ? options.split("\n").map(term => term.trim() || null) : options

    return (
        <div className={`checkboxes ${ type === 'radios' ? 'radio' : '' }`}>
            {lines.map((term, index) => {
                if(!term){
                    return null
                }

                return (
                    <div className="checkbox" key={index}>
                        <label>
                            <span className="checkbox-container">
                                <input 
                                    type="checkbox" 
                                    checked={value.indexOf(term) != -1}
                                    onChange={() => _handleChange(term)}
                                />
                                <span className="checkmark"/>
                            </span>
                            <span className="text" dangerouslySetInnerHTML={{ __html: term}} />
                        </label>
                    </div>
                )
            })}
        </div>
    )
}